module.exports = __webpack_public_path__ + "static/media/locknox-5.15bb7ceb.jpg";